export { default as MainLayout } from './Main';
export type { WithLayout } from './layouts';